import type { MemberRole } from '@web/data/repositories';
import { t } from '@web/i18n';
import { AppIcons, type AppIconName } from '@web/ui/core';
import { twcn } from '@web/ui/core/utils';

const ROLE_ICONS: Record<MemberRole, AppIconName> = {
  guest: 'user',
  member: 'user-check',
  admin: 'shield-check',
  owner: 'crown',
};

const ROLE_TONE: Record<MemberRole, string> = {
  guest: 'bg-tone-gray-tint text-tone-gray-ink',
  member: 'bg-primary-tint text-primary-ink',
  admin: 'bg-ai-tint text-ai-ink',
  owner: 'bg-vip-tint text-vip',
};

export function RoleChip({ role }: Readonly<{ role: MemberRole }>): React.JSX.Element {
  return (
    <span
      className={twcn(
        'inline-flex h-5.5 items-center gap-1.5 rounded-pill px-2 text-micro font-medium',
        ROLE_TONE[role],
      )}
    >
      <AppIcons name={ROLE_ICONS[role]} size={11} />
      {t(`members.role.${role}`)}
    </span>
  );
}
